<template>
  <div>
    <nav-bar ref="form"/>
    <div id="comparePage ">
      <div class="sec-wight-bg py-16 ">
        <div class="container sec-garay-bg border-radius ">
          <div class="row ">
            <h5 class="text-blue col py-0">
              <page-title :titles="'مقایسه محصولات'"/>
            </h5>
          </div>
        </div>
        <div class="min-height"></div>
        <div class="container" v-if="isLoaded">
          <div class="row mt-3" v-if="comparedProducts.length >0">
            <div class="col mx-3">
              <div class="table-responsive text-center">
                <table class="table table-bordered " id="table-compare">
                  <tbody>
                  <tr>
                    <td>تصویر</td>
                    <td v-for="item in comparedProducts" :key="item.id">
                      <router-link :to="{path:'productDetails',query:{productId:item.id}}">
                        <v-img :src="$replaceHttps(item.imageUrl)" height="100" width="100"
                               class="d-block mx-auto"></v-img>
                      </router-link>
                    </td>
                  </tr>
                  <tr>
                    <td>نام کامل</td>
                    <td v-for="item in comparedProducts" :key="item.id">{{ item.productName }}</td>
                  </tr>
                  <tr>
                    <td>InterNational Size Rating</td>
                    <td v-for="item in comparedProducts" :key="item.id">{{ item.interNationalSizeRating }}</td>
                  </tr>
                  <tr>
                    <td>Screw Diameter</td>
                    <td v-for="item in comparedProducts" :key="item.id">{{ item.screwDiameter }}</td>
                  </tr>
                  <tr>
                    <td>Theoretical Shot Volume</td>
                    <td v-for="item in comparedProducts" :key="item.id">{{ item.theoreticalShotVolume }}</td>
                  </tr>
                  <tr>
                    <td>Theoretical Shot Weight</td>
                    <td v-for="item in comparedProducts" :key="item.id">{{ item.theoreticalShotWeight }}</td>
                  </tr>
                  <tr>
                    <td>Screw L:D Ratio</td>
                    <td v-for="item in comparedProducts" :key="item.id">{{ item.screwLDRatio }}</td>
                  </tr>
                  <tr>
                    <td>Injection Pressure</td>
                    <td v-for="item in comparedProducts" :key="item.id">{{ item.injectionPressure }}</td>
                  </tr>
                  <tr>
                    <td>Screw Speed</td>
                    <td v-for="item in comparedProducts" :key="item.id">{{ item.screwSpeed }}</td>
                  </tr>
                  <tr>
                    <td>Clamping Force</td>
                    <td v-for="item in comparedProducts" :key="item.id">{{ item.clampingForce }}</td>
                  </tr>
                  <tr>
                    <td>Max Daylight</td>
                    <td v-for="item in comparedProducts" :key="item.id">{{ item.maxDaylight }}</td>
                  </tr>
                  <tr>
                    <td>Mould Opening Stroke</td>
                    <td v-for="item in comparedProducts" :key="item.id">{{ item.mouldOpeningStroke }}</td>
                  </tr>
                  <tr>
                    <td>Platen Size</td>
                    <td v-for="item in comparedProducts" :key="item.id">{{ item.platenSize }}</td>
                  </tr>
                  <tr>
                    <td>Space Between Tie Bar</td>
                    <td v-for="item in comparedProducts" :key="item.id">{{ item.spaceBetweenTieBar }}</td>
                  </tr>
                  <tr>
                    <td>Mould Thickness min/max</td>
                    <td v-for="item in comparedProducts" :key="item.id">{{ item.mouldThickness }}</td>
                  </tr>
                  <tr>
                    <td>Ejector Force</td>
                    <td v-for="item in comparedProducts" :key="item.id">{{ item.ejectorForce }}</td>
                  </tr>
                  <tr>
                    <td>Ejector Stroke</td>
                    <td v-for="item in comparedProducts" :key="item.id">{{ item.ejectorStroke }}</td>
                  </tr>
                  <tr>
                    <td>Number Of Thimbles</td>
                    <td v-for="item in comparedProducts" :key="item.id">{{ item.numberOfThimbles }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <v-alert
              class="container my-5"
              v-else
              dense
              outlined
              type="error">شما موردی برای مقایسه انتخاب نکرده اید.
          </v-alert>
        </div>
        <Footer/>
        <v-dialog
            v-model="showResultDialog"
            hide-overlay
            persistent
            width="500">
          <v-card class="text-center">
            <v-card-title class="justify-space-between green-bg">
              <v-btn
                  class="mr-2"
                  icon
                  @click="showResultDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text class="pt-6">
              <div class="mb-0 black--text py-5">{{ dialogResult }}</div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
      <footer-menu></footer-menu>
      <v-overlay
          id="searchOverLay"
          :absolute="false"
          :color="'#f7f1fc'"
          :opacity="0.7"
          :value="showLoaderDialog"
          :z-index="6">
        <div class="row h-100 align-items-center justify-content-center">
          <div class="loading-spinner">
          </div>
        </div>
      </v-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import FooterMenu from "@/components/footer";
import PageTitle from "@/components/titles";

export default {
  name: "compare-page",
  components: {PageTitle, FooterMenu, NavBar},
  metaInfo: {
    title: 'ماشین سازان اصلانیان-مقایسه محصولات'
  },
  data: () => ({
    isLoaded: false,
    comparedProducts: [],
    showResultDialog: false,
    dialogResult: '',
    showLoaderDialog: false,

  }),
  mounted() {
    this.getData()
  },
  methods: {
    getImgUrl(pic) {
      return require('../assets/img/' + pic)
    },
    getData() {
      this.showLoaderDialog = true;
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "Home/CompareProducts?ProductIds=" + this.$global.comparelist, requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.comparedProducts = json
            this.isLoaded = true
            this.showLoaderDialog = false;
          })
          .catch(error => console.log('error', error));

    }
  }
}
</script>

<style scoped>

</style>